import * as React from 'react';
import s from './collection.scss';
import type { ICollectionHeaderProps } from '../collection-header';
import {
  CollectionHeader,
  dtoToCollectionHeaderProps,
} from '../collection-header';
import { CollectionDescription } from '../collection-description';
import type { ISolutionGridWrapperProps } from '../../solution-grid-wrapper/solution-grid-wrapper';
import { SolutionGridWrapper } from '../../solution-grid-wrapper/solution-grid-wrapper';
import { FluidContainer } from '../../FluidContainer';
import { Box, Text } from '@wix/design-system';
import { composer } from '../../../component-decorators/composer';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { getCollectionDefinition } from '@wix/app-market-collection-widget';
import type { GetWebSolutionsByTagsResponse } from '@wix/ambassador-marketplace/types';
import { Type } from '@wix/ambassador-marketplace/types';

export interface ICollectionProps extends Partial<WithTranslationProps> {
  headerProps: ICollectionHeaderProps;
  description: string;
  appsCount: number;
  solutionGridWrapperProps: ISolutionGridWrapperProps;
}

export const dtoToCollectionProps = (
  res: GetWebSolutionsByTagsResponse,
): ICollectionProps => {
  const headerProps = dtoToCollectionHeaderProps(res);
  const description = res?.tagsAndSubCategories?.[0]?.tag?.description || '';
  const appsCount = res.webSolutions.length;
  const solutionGridWrapperProps = {
    solutions: res.webSolutions
      .filter((solution) => solution.baseInfo.type === Type.APP)
      .map((solution, appIndex) => {
        return {
          appIndex,
          isPreInstalled: solution?.baseInfo?.showRegularAppPage,
          ...solution.baseInfo,
        };
      }),
    isCompany: true,
    referralSectionName: getCollectionDefinition(
      res.tagsAndSubCategories[0].tag,
    ).slug,
  };
  return {
    headerProps,
    description,
    appsCount,
    solutionGridWrapperProps,
  };
};

export const Collection = composer()
  .withTranslation()
  .compose(
    ({
      headerProps,
      description,
      appsCount,
      solutionGridWrapperProps,
      t,
    }: ICollectionProps) => {
      return (
        <div data-testid="collection">
          <FluidContainer className={s.newHeaderWrapper}>
            <CollectionHeader {...headerProps} />
            <CollectionDescription description={description} wordsLimit={70} />
            <Box
              marginTop="24px"
              marginBottom="3px"
              className={s.mobileHeaderSpacing}
            >
              <Text className={s.appsCount} tagName="h2" secondary>
                {t('collection.apps-counter', { appsCount })}{' '}
              </Text>
            </Box>
            <SolutionGridWrapper {...solutionGridWrapperProps} />
          </FluidContainer>
        </div>
      );
    },
  );
